// src/pages/ChildCare.jsx
import React from 'react';

function ChildCare() {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Under 5 Child Care Package</h1>

      <div className="row g-4">
        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-dark text-white">
              <h4>Growth & Development</h4>
            </div>
            <div className="card-body">
              <ul>
                <li>Monthly growth tracking</li>
                <li>Milestone assessments</li>
                <li>Early intervention programs</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-dark text-white">
              <h4>Health Protection</h4>
            </div>
            <div className="card-body">
              <h5>Vaccination Schedule</h5>
              <ul>
                <li>DTP</li>
                <li>MMR</li>
                <li>Hepatitis B</li>
                <li>Polio</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-header bg-dark text-white">
              <h4>Parental Guidance</h4>
            </div>
            <div className="card-body">
              <ul>
                <li>Nutrition planning</li>
                <li>Safety childproofing</li>
                <li>Positive discipline</li>
                <li>Sleep training</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-12 mb-5">
          <div className="card">
            <div className="card-header bg-dark text-white">
              <h4>Essential Care Components</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5>Physical Care</h5>
                  <ul>
                    <li>Proper hygiene practices</li>
                    <li>Regular health screenings</li>
                    <li>Physical activity plans</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5>Emotional Care</h5>
                  <ul>
                    <li>Bonding activities</li>
                    <li>Stress management</li>
                    <li>Social development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChildCare;